module.exports = __webpack_public_path__ + "static/media/bg-4.067cbb13.jpg";